import React from 'react';
import styles from '../style.module.scss';

import { FormatInteger } from 'utils/format';

const t = {
  kg: 'Kg',
};

const MaxWeight = ({ cellData }) => {
  return (
    <div className={styles.rightCell}>
      {cellData && cellData > 0 ? (
        <span>
          <FormatInteger value={cellData} />
          &nbsp;
          {t.kg}
        </span>
      ) : null}
    </div>
  );
};

export default MaxWeight;
